import { render, staticRenderFns } from "./BlockNotifications.vue?vue&type=template&id=d432f602"
import script from "./BlockNotifications.vue?vue&type=script&lang=js"
export * from "./BlockNotifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports